import React from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Login from './pages/Login';
import Home from './pages/Home';
import RequestForApproval from './pages/RequestForApproval';
import DashboardReport from './pages/DashboardReport';
import StatusReport from './pages/StatusReport';
import { LoadingProvider } from './Utils/LoadingContext';
import LoadingSpinner from './components/LoadingSpinner';
import { ToastContainer } from 'react-toastify';
import ProtectedRoute from './components/ProtectedRoute';
import { isTokenValid } from './Utils/authHelper';
import TatReport from './pages/TatReport';
import { WarningProvider } from './Utils/WarningContext';
import SmartReportPage from './pages/SmartReportPage';
import EditRequest from './pages/EditRequest';

function App() {
  const location = useLocation();
  const showHeaderFooter = location.pathname !== '/login';

  const token = localStorage.getItem("token");
  const isLoggedIn = token && isTokenValid(token);

  return (
    <LoadingProvider>
      <WarningProvider isLoggedIn={isLoggedIn}>
      <div>
        <ToastContainer position="bottom-right" autoClose={5000} />
        <LoadingSpinner />
      </div>
      <div>
        {showHeaderFooter && <Header />}

        <Routes>
          {/* Redirect root '/' to '/login' or '/home' based on login */}
          <Route path="/" element={<Navigate to={isLoggedIn ? "/home" : "/login"} />} />

          {/* Login should redirect to /home if already logged in */}
          <Route
            path="/login"
            element={isLoggedIn ? <Navigate to="/home" replace /> : <Login />}
          />

          {/* Protected Routes */}
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/create-request"
            element={
              <ProtectedRoute>
                <RequestForApproval />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard-report"
            element={
              <ProtectedRoute>
                <DashboardReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/status-report"
            element={
              <ProtectedRoute>
                <StatusReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tat-report"
            element={
              <ProtectedRoute>
                <TatReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/smart-report"
            element={
              <ProtectedRoute>
                <SmartReportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/editDetails"
            element={
              <ProtectedRoute>
                <EditRequest />
              </ProtectedRoute>
            }
          />
        </Routes>

        {showHeaderFooter && <Footer />}
      </div>
      </WarningProvider>
    </LoadingProvider>
  );
}

export default App;
